/**
 * Enum matching the backend AnalystSeniority enum
 */
export enum AnalystSeniority {
  JUNIOR = 'JUNIOR',
  SENIOR = 'SENIOR',
}

export type RawAnalystSeniority = {
  seniority: AnalystSeniority;
};
